import env from "@/env";

let API_URL = "";
let ROOT_URL = "";

if (process.env.envmode == "dev" || process.env.envmode == "development") {
    API_URL = env.API_DEV;
    ROOT_URL = env.ROOT_DEV;
} else if (process.env.envmode == "test") {
    API_URL = env.API_TEST;
    ROOT_URL = env.ROOT_TEST;
} else if (
    process.env.envmode == "prod" ||
    process.env.envmode == "production"
) {
    API_URL = env.API_PROD;
    ROOT_URL = env.ROOT_PROD;
}

export default {
    usersList: API_URL + "/user/search/",

    userChangeStatus: API_URL + "/user/change_status",

    //admins
    register: API_URL + "/admin/register",

    changeRole: API_URL + "/admin/change_role",

    changePassword: API_URL + "/admin/change_password",

    delete: API_URL + "/admin/delete",

    login: API_URL + "/admin/login",

    logout: API_URL + "/admin/logout",

    adminInfo: API_URL + "/admin/info",

    getAdmin: API_URL + "/admin/get",

    adminsList: API_URL + "/admin/list",

    ebarimtSend: API_URL + "/admin/send_data",

    executeFailedData: API_URL + "/admin/execute_failed_data",

    failedDataCount: API_URL + "/admin/failed_data_count",

    //entries
    viewEntry: API_URL + "/entry/view",

    getEntry: API_URL + "/entry/get",

    changeStatus: API_URL + "/entry/content_status",

    changeTopStatus: API_URL + "/entry/topmenu_status",

    changeSubStatus: API_URL + "/entry/submenu_status",

    //article, cardinfo and branches
    createArticle: API_URL + "/entry/create_article",

    editArticle: API_URL + "/entry/modify_article",

    createBranch: API_URL + "/entry/create_branch",

    editBranch: API_URL + "/entry/modify_branch",

    createCard: API_URL + "/entry/create_card",

    editCard: API_URL + "/entry/modify_card",

    //top and sub menus
    menusList: API_URL + "/entry/menu",

    createSubmenu: API_URL + "/entry/create_submenu",

    editSubmenu: API_URL + "/entry/modify_submenu",

    createTopmenu: API_URL + "/entry/create_topmenu",

    editTopmenu: API_URL + "/entry/modify_topmenu",

    //banners
    bannersList: API_URL + "/banner/list",

    createBanner: API_URL + "/banner/create",

    deleteBanner: API_URL + "/banner/delete",

    editBanner: API_URL + "/banner/modify",

    getBanner: API_URL + "/banner/get",

    //statistics
    stat: API_URL + "/stat/",

    //design
    setHsDesign: API_URL + "/design/set_slides",

    setBgDesign: API_URL + "/design/set_bg",

    getDesign: API_URL + "/design/get?web=1",

    setPopupDesign: API_URL + "/design/set_popup",

    //inquiry
    inquiry: API_URL + "/inquiry",

    imageUpload: ROOT_URL + "/img_upload",
};
